import LandingPage from './container';

export default LandingPage;
